<template>
	<el-row>
		<el-row :gutter="0">
			<el-col :span="9">
				<div class="search-view">
					<div style="margin-right: 10px;">会员id:</div>
					<el-input size="mini" v-model="memberId" type="number"></el-input>
					<el-button type="primary" size="mini" style="margin-left: 10px;" @click="shuaixuan">筛选</el-button>
					<el-button type="infor" size="mini" @click="daochu">导出报表</el-button>
					<el-button type="infor" size="mini" @click="zhikong">置空</el-button>
				</div>
			</el-col>
		</el-row>
		<div style="width: 90%;display: flex;align-items: center;justify-content: space-between;height: 100px;">
			<div>
				券id: {{this.$route.query.id}}
			</div>
			<div>
				券名称: {{this.$route.query.name}}
			</div>
			<div>
				面值: {{this.$route.query.amount}}
			</div>
			<div>
				使用门槛: {{this.$route.query.minPoint}}
			</div>
			<div>
				创建者: {{this.$route.query.crteateUser}}
			</div>
			<div>
				有效期:{{this.$route.query.expireDays}}天以后
			</div>
			<div>
				创建时间: {{this.$route.query.created}}
			</div>
		</div>

		<el-table :data="tableDate">
			<el-table-column label="序号" prop="historyId"></el-table-column>
			<el-table-column label="用户id" prop="memberId"></el-table-column>
			<el-table-column label="用户昵称" prop="wxName"></el-table-column>
			<el-table-column label="获得时间" prop="getTime"></el-table-column>
			<el-table-column label="到期时间" prop="endTime"></el-table-column>
			<el-table-column label="状态" prop="id">
				<template slot-scope="scope">
					<span v-if="scope.row.useStatus == 0">未使用</span>
					<span v-if="scope.row.useStatus == 1">已使用</span>
					<span v-if="scope.row.useStatus == 2">已过期</span>
				</template>
			</el-table-column>
			<!-- <el-table-column label="使用状态" prop="useStatus">
				<template slot-scope="scope">
					<span v-if="scope.row.useStatus == 0">未使用</span>
					<span v-if="scope.row.useStatus == 1">已使用</span>
					<span v-if="scope.row.useStatus == 2">已过期</span>
				</template>
			</el-table-column> -->
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" style="color: red;" v-if="scope.row.useStatus == 0"
						@click="feiqi(scope.row)">废弃</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px 30%;">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30,50,100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				memberId: '',
				tableDate: [],
				pageNum: 1,
				pageSize: 30,
				total: 0,
			}
		},
		methods: {
			zhikong() {
				this.memberId = ''
				this.getInfo()
			},
			getInfo() {
				this.$http.get(
					`/api/course/clrCouponController/selectCouponUseInfoById?id=${this.$route.query.id}&memberId=${this.memberId}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`
				).then(res => {
					this.total = res.data.data.total
					this.tableDate = res.data.data.list
				})
			},
			shuaixuan() {
				this.getInfo()
			},
			daochu() {
				this.$http.post(`/api/course/clrCouponController/exportExcel`, {
					memberId: this.memberId,
					couponId: this.$route.query.id
				}, {
					responseType: 'blob'
				}).then(res => {
					console.log(res);
					this.$message({
						type: 'info',
						message: '正在导出优惠券表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '优惠券列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			feiqi(row) {
				console.log(row);
				this.$confirm('此操作将永久废弃该优惠券, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(`/api/course/clrCouponController/discardThisCoupon?id=${row.historyId}`, {})
						.then(res => {
							if (res.data.status == 0) {
								this.$message({
									type: 'success',
									message: res.data.data
								});
								this.getInfo()
							} else {
								this.$message.error(res.data.msg)
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getList()
			},
			//页数
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getList()
			},
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped="scoped">

</style>
